<template>
  <div :style="cellStyle" class="cell-block cell-block-unavailability">
    <div v-tooltip="tooltipConfig" :class="cellClasses"></div>
  </div>
</template>

<script>
import format from "../../../mixins/format";

export default {
  mixins: [format],

  props: ["unavailability", "length", "adjust", "type"],

  computed: {
    tooltipContent() {
      if (this.unavailability.start_from_time && this.unavailability.end_by_time) {
        const startFormat =
          this.unavailability.start_from_time === "00:00:00" ? "ddd DD MMM" : "ddd DD MMM@hh:mma";
        const endFormat =
          this.unavailability.end_by_time === "23:59:59" ? "ddd DD MMM" : "ddd DD MMM@hh:mma";

        const start = this.formatDate(this.unavailability.start_from, startFormat);
        const end = this.formatDate(this.unavailability.end_by, endFormat);

        return (
          `<div>${start} - ${end}</div>` +
          `<div>${this.$lodash.get(this.unavailability, "reason", null)}</div>`
        );
      }

      if (this.type === "public-holiday") {
        return `<div>${this.unavailability.reason} ${this.unavailability.inStates}</div>`;
      }

      return `<div>${this.unavailability.reason}</div>`;
    },

    tooltipConfig() {
      return {
        content: this.tooltipContent,
        classes: [`cell-small-tooltip-theme-${this.type}`],
        placement: "top-start",
      };
    },

    cellStyle() {
      const length = this.length > 13 ? 13 : this.length;

      return {
        width: `calc(${length * 100.6}% + ${length + 1}px)`,
        height: "100%",
        left: this.adjust ? "50%" : "",
      };
    },

    cellClasses() {
      return ["cell-tooltip", `cell-${this.type}`];
    },
  },
};
</script>
